import { render, staticRenderFns } from "./AttractionInformation.vue?vue&type=template&id=ffb0a232&scoped=true&"
import script from "./AttractionInformation.vue?vue&type=script&lang=js&"
export * from "./AttractionInformation.vue?vue&type=script&lang=js&"
import style0 from "./AttractionInformation.vue?vue&type=style&index=0&id=ffb0a232&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffb0a232",
  null
  
)

export default component.exports